<template>
  <div class="return-register">
    <!-- 运单登记 -->
    <div class="return-register-left">
      <p class="register-title">运单登记</p>
      <el-form ref="form" :model="register">
        <el-form-item label="承运商：" prop="expressType">
          <el-select
            v-model="register.expressType"
            filterable
            clearable
            placeholder="请选择承运商"
          >
            <el-option
              v-for="item in expressList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号：" prop="expressCode">
          <el-input v-model="register.expressCode" placeholder="请输入运单号" />
        </el-form-item>
        <el-form-item class="btn-container">
          <el-button :disabled="register.isAutoSubmit" :class="!register.isAutoSubmit?'btn-blue':'btn-gray'" @click="registerFnc">登记</el-button>
        </el-form-item>
        <el-form-item class="auto-submit">
          <el-switch
            v-model="register.isAutoSubmit"
            active-color="#2E68EA"
            active-text="自动提交"
            inactive-color="#C5C5C5">
          </el-switch>
        </el-form-item>
      </el-form>
    </div>

    <!-- 退货登记列表 -->
    <div class="return-register-right">
      <el-form ref="searchForm" class="search-form" :model="searchForm">
        <div class="search-row">
          <el-form-item label="承运商：" prop="expressType">
            <el-select
              v-model="searchForm.expressType"
              filterable
              clearable
              placeholder="请选择承运商"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="search-row">
          <el-form-item label="运单号：" prop="expressCode">
            <el-input v-model="searchForm.expressCode" placeholder="请输入运单号" />
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-select
              v-model="searchForm.status"
              filterable
              clearable
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in RETURN_REGISTER_STATUS_LIST"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset('searchForm')">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="title-container">
        <p class="table-title">退货登记信息</p>
        <div class="upload-return" @click="downExcel">
          <span class="upload-return-img"></span>
          <span>导出</span>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item,index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="scope.row.status?'processed':'not-processed'">
                {{scope.row[item.prop]}}
              </div>
              <p v-else>{{scope.row[item.prop]}}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button 
                :disabled="scope.row.status == 1"
                type="text" 
                :class="!scope.row.status?'btn-text':'btn-text-gray'" 
                @click="del(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>

    <!-- 在途运单 -->
    <div class="suspension" :class="isShowSuspension?'open':'close'" v-show="isOpenSuspension">
      <div class="suspension-title">
        <div class="suspension-title-left">
          <img class="sign" src="~assets/images/sigh/sigh-blue.png">
          <span>在途运单：目前还在运输途中的退货运单</span>
          <span class="order-nums">（{{ transitWayBillOrderNums }}）</span>
        </div>
        <div class="suspension-title-right">
          <span @click="isShowSuspension = true" class="details-btn" v-if="!isShowSuspension">展开详情</span>
          <span @click="isShowSuspension = false" class="details-btn" v-else>收起详情</span>
          <img @click="isOpenSuspension = false" class="close-img" src="~assets/images/close.png">
        </div>
      </div>
      <div class="suspension-content" v-show="isShowSuspension">
        <div class="border"></div>
        <div class="transit-waybill-info">
          <p class="sub-title">在途运单明细</p>
          <el-collapse accordion>
            <el-collapse-item
              v-for="(item, index) in list"
              :key="index"
              :name="index"
            >
              <template slot="title">
                <img class="arrow-right" src="~assets/images/arrow/arrow-right.png">
                <span>{{ item.title }}</span>
                <div class="nums">
                  <span>（数量：{{ item.nums }}）</span>
                </div>
              </template>
              <div
                class="express-code"
              >
                <div
                  class="express-code-row"
                  v-for="(item, jndex) in item.list"
                  :key="jndex"
                >
                  运单号：{{ item.expressCode }}
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import ReturnRegister from "models/return-register";
import expressMixins from "@/common/mixins/express.js"
import statusMixins from "@/common/mixins/status.js"
import { formatTimeToDate, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [expressMixins, statusMixins],
  components: {
    PaginationTpl
  },
  data() {
    return {
      // 运单登记
      register: {
        expressType: null,
        expressCode: '',
        isAutoSubmit: true,
      },
      searchForm: {
        expressType: null,
        expressCode: '',
        date: '',
        status: '',
      },
      tableData: [],
      tableTitle: [
        {label: '日期', prop: 'date'},
        {label: '承运商', prop: 'expressName'},
        {label: '单号', prop: 'expressCode'},
        {label: '状态', prop: 'statusVal'},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,

      // 在途运单列表
      list: [],
      // 在途运单总条数
      transitWayBillOrderNums: 0,
      // 是否打开在途运单弹框
      isOpenSuspension: true,
      // 是否展开在途运单详情
      isShowSuspension: false,
    }
  },
  watch: {
    'register.isAutoSubmit': {
      handler(newVal) {
        if (!newVal) {
          console.log('取消监听');
          window.document.onkeypress = null
        } else {
          console.log('开启监听');
          this.watchBarCodeScanningGun()
        }
      }
    }
  },

  created() {
    this.initExpressList()
    this.initList()
    this.watchBarCodeScanningGun()
    this.initTransitWaybillList()
  },
  destroyed() {
    window.document.onkeypress = null
  },

  methods: {
    /**
     * @desc 获取退货登记列表
     */
    initList() {
      let pageNo = this.currentPage;
      let carrierId = this.searchForm.expressType;
      let expressCode = this.searchForm.expressCode;
      let date = this.searchForm.date;
      let hasDeal = this.searchForm.status;
      let data = {
        pageNo,
        carrierId,
        expressCode,
        date,
        hasDeal
      }
      ReturnRegister.getList(data).then(res => {
        if (res.success) {
          let { records, total } = res.result
          let tableData = [];
          this.total = total;
          records.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.date = value.createTime != 0? formatTimeToDate(value.createTime) :'';
            obj.expressName = value.carrier;
            obj.expressCode = value.expressCode;
            obj.status = value.hasDeal;
            obj.statusVal = this.RETURN_REGISTER_STATUS[value.hasDeal];
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    /** 
     * @desc 获取在途运单列表
    */
    initTransitWaybillList() {
      ReturnRegister.getTransitWaybillList().then(res => {
        if (res.success) {
          let { count, list } = res.result
          this.transitWayBillOrderNums = count
          let arr = [];
          for (let key in list) {
            let obj = {}
            let i = list[key]
            obj.title = key
            obj.nums = i.length
            obj.list = []
            i.map(j => {
              let obj2 = {}
              obj2.expressCode = j.expressCode
              obj.list.push(obj2)
            })
            arr.push(obj)
          }
          this.list = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    /**
     * @desc 运单登记
     */
    registerFnc() {
      let carrierId = this.register.expressType
      let expressCode = this.register.expressCode
      let data = {
        carrierId,
        expressCode
      };
      ReturnRegister.postRegister(data).then(res => {
        if (res.success) {
          this.initList();
          this.register.expressCode = ''
          this.$message.success("登记成功");
        } else {
          this.register.expressCode = ''
          this.$message.error(res.message);
        }
      });
    },
    
    searchData() {
      this.currentPage = 1
      this.initList();
    },

    reset(formName) {
      this.$refs[formName].resetFields();
    },
    
    /**
     * @desc 导出退货登记
     */
    downExcel() {
      let carrierId = this.searchForm.expressType;
      let expressCode = this.searchForm.expressCode;
      let date = this.searchForm.date;
      let hasDeal = this.searchForm.status;
      let data = {
        carrierId,
        expressCode,
        date,
        hasDeal
      }
      ReturnRegister.getExportExcel(data).then(res => {
        downLoadFileByBlob(res)
      });
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    /**
     * @desc 删除退货登记
     */
    del(id) {
      this.$confirm("删除后，该运单将无法进行退货处理，请确认", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      })
        .then(() => {
          ReturnRegister.postDelList(id).then(res => {
            if (res.success) {
              this.initList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    /**
     * @desc 监听扫码枪
     */
    watchBarCodeScanningGun() {
      let code = ''
      let lastTime, nextTime // 上次时间，最新时间
      let lastCode, nextCode // 上次按键，最新按键
      window.document.onkeypress = (e) => {
        // 获取按键
        if (window.event) { // IE
          nextCode = e.keyCode
        } else if (e.which) {
          nextCode = e.which
        }

        // 如果触发了回车事件（扫码结束时间）
        if (e.which === 13) {
          // 扫码枪的速度很快，手动输入的时间不回让code的长度大于2，所以这里只对邵美琪有效
          if (code.length < 3) return
          // 获取到扫码枪输入的内容，做别的操作
          this.parseQRCode(code)
          lastCode = ''
          lastTime = ''
          return
        }

        // 记录最新时间
        nextTime = new Date().getTime()
        // 如果上次时间和上次按键为空
        if (!lastTime && !lastCode) {
          // 清空上次的条形码
          code = ''
          code += e.key
          console.log('扫码开始', code);
        }
        // 如果有上次时间和上次按键
        if (lastTime && lastTime && nextTime - lastTime > 100) {  
          // 当扫码前有keypress事件时，防止首字母缺失
          code = e.key
          console.log('防止首字母缺失', code);
        } else if(lastCode && lastTime) {
          code += e.key
          console.log('扫码中', code);
        }
        lastCode = nextCode
        lastTime = nextTime
      }
    },

    /**
     * @desc 获取到扫码枪输入的内容，做别的操作
     */
    parseQRCode(code) {
      if (code.length === 13 || code.length === 14 || code.length === 15 || code.length === 16 || code.length === 17) {
        console.log('barCode', code);
      } else if (code.length === 23 || code.length === 30) {
        console.log('B类条形码', code);
      } else if (code.length === 0) {
        console.log('请输入条码', code);
        this.$message({
          message: '请输入条码',
          type: 'error'
        })
        return
      } else {
        console.log('条码不合法', code);
        this.$message({
          message: '条码不合法',
          type: 'error'
        })
        return
      }
      this.register.expressCode = code
      this.registerFnc()
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/production/return-register.scss';
</style>
